var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"8":1,"25":1,"34":1,"75":1,"106":1,"110":1,"178":1,"236":1,"244":1,"484":1,"563":1,"691":1,"830":1,"843":1,"904":1,"915":1,"995":1,"1156":1,"1166":1,"1171":1,"1235":1,"1352":1,"1439":1,"1453":1,"1458":1,"1519":1,"1545":1,"1620":1,"1634":1,"1865":1,"1964":1,"1972":1,"2073":1,"2108":1,"2155":1,"2279":1,"2301":1,"2323":1,"2343":1,"2438":1,"2508":1,"2694":1,"2758":1,"2764":1,"2849":1,"2859":1,"2967":1,"2986":1,"3055":1,"3076":1,"3098":1,"3169":1,"3248":1,"3351":1,"3366":1,"3550":1,"3615":1,"3667":1,"3754":1,"3823":1,"4044":1,"4050":1,"4287":1,"4294":1,"4476":1,"4541":1,"4547":1,"4634":1,"4688":1,"4704":1,"4706":1,"4902":1,"5033":1,"5077":1,"5138":1,"5161":1,"5274":1,"5301":1,"5342":1,"5372":1,"5518":1,"5540":1,"5576":1,"5663":1,"5698":1,"5706":1,"5757":1,"5767":1,"5769":1,"5781":1,"5801":1,"6009":1,"6045":1,"6075":1,"6116":1,"6232":1,"6332":1,"6436":1,"6499":1,"6507":1,"6591":1,"6598":1,"6609":1,"6655":1,"6780":1,"6828":1,"6856":1,"6862":1,"6963":1,"6975":1,"7096":1,"7220":1,"7332":1,"7454":1,"7455":1,"7505":1,"7529":1,"7642":1,"7669":1,"7680":1,"7684":1,"7802":1,"7804":1,"7843":1,"7890":1,"7975":1,"8043":1,"8048":1,"8077":1,"8131":1,"8197":1,"8241":1,"8271":1,"8275":1,"8280":1,"8520":1,"8546":1,"8574":1,"8584":1,"8732":1,"8931":1,"9000":1,"9079":1,"9102":1,"9201":1,"9230":1,"9338":1,"9368":1,"9540":1,"9626":1,"9640":1,"9652":1,"9667":1,"9740":1,"9758":1,"9914":1,"9998":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr